import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	width: -webkit-fill-available;
	position: relative;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	border: 1px solid var(--border-color);
	border-inline-start-width: 3px;
	border-radius: 6px;
	background-color: var(--input-bg-color);
	container-type: inline-size;

	&.bigger {
		gap: 16px;
		padding: 16px;
		border-radius: 4px;

		@media ${Breakpoints.mobile} {
			gap: 12px;
			padding: 16px 12px;
		}
	}

	&.notification {
		gap: 24px;
		padding: 24px;
		border-radius: 12px;
		border-inline-start-width: 4px;
		box-shadow: var(--container-box-shadow);

		@media ${Breakpoints.mobile} {
			gap: 16px;
			padding: 16px 12px;
		}
	}

	&.closeable {
		padding-inline-end: 36px;
	}

	&.info {
		border-inline-start-color: var(--blue);
	}

	&.success {
		border-inline-start-color: var(--green);
	}

	&.warning {
		border-inline-start-color: var(--yellow);
	}

	&.notice {
		border-inline-start-color: #ff9008; // this color will be added to the design system in the future
	}

	&.error {
		border-inline-start-color: var(--red);
	}

	&.update {
		border-inline-start-color: var(--yellow-80);
	}

	.alert-link {
		flex-shrink: 0;
		margin: auto 0;
		margin-inline-start: -1rem;

		> .typography {
			text-decoration: underline;
		}

		@media ${Breakpoints.mobile} {
			flex-shrink: unset;
		}
	}

	body[dir='rtl'] & {
		border-width: 1px 3px 1px 1px;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	&.compact {
		flex-direction: row;
		gap: 1rem;

		@container (width <  500px) {
			flex-direction: column;
			gap: unset;
		}
	}
`;

export const AlertIcon = styled.div`
	display: flex;
	align-self: flex-start;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 0.5rem;
	width: 100%;

	> .typography {
		line-height: 1.3;
	}
`;

export const CloseButtonContainer = styled.div`
	position: absolute;
	top: 12px;
	right: 12px;

	body[dir='rtl'] & {
		right: unset;
		left: 12px;
	}

	> .button {
		width: 24px !important;
		height: 24px !important;
		background-color: var(--alert-close-button-bg);

		> .icon {
			color: var(--alert-close-button-icon-color);
		}

		:hover {
			background-color: var(--black-20) !important;

			> .icon {
				color: var(--alert-close-button-icon-color) !important;
			}
		}
	}

	&.compact {
		top: 14px;
		right: 14px;

		> .button {
			width: 20px !important;
			height: 20px !important;
		}
	}

	@media ${Breakpoints.mobile} {
		top: 8px;
		right: 8px;

		body[dir='rtl'] & {
			right: unset;
			left: 8px;
		}
	}
`;
